import { displayMatchTypes, inputCategories } from '@/common/components/MatchTypeEditor/constants'
import { getInputCategory } from '@/common/components/MatchTypeEditor/helpers'

export const getDefaultMatchValues = matchType => {
  const category = getInputCategory(matchType)
  if (category === inputCategories.multiValue) return []
  if (category === inputCategories.region) return []
  return null
}

export const isBooleanField = fieldConfig => {
  const fieldMatchTypes = fieldConfig?.matchTypes || []
  return fieldMatchTypes.length === 1 && fieldMatchTypes[0] === displayMatchTypes.boolean
}
